import { CURRENCY } from 'src/enums';

export enum WML {
  w = 'Priced Below',
  m = 'Similar Price',
  l = 'Priced Above',
}
export enum MatchType {
  ALL = '-1',
  EXACT = 'EXACT',
  LIKE = 'LIKE',
}

export enum VarianceType {
  Lowest = '2',
  Regular = '1',
}

export type AlertResult = {
  categoryName: string;
  sourceOwnerName: string;
  sourceProductId: number;
  sourceProductName: string;
  sourceProductUrl: string | null;
  uniqueIdentifier: string;
  sourceRegionName: string;
  sourceCurrency: keyof typeof CURRENCY;
  sourceRegularPrice: number;
  sourceLowestPrice: number;
  sourceLowestPriceType: string;
  matchType: keyof typeof MatchType;
  priceType: keyof typeof VarianceType;
  sourceCompetitorPriceVariance: number;
  sourceCompetitorLowestPriceVariance: number;
  competitorCurrency: keyof typeof CURRENCY;
  competitorProductUrl: string | null;
  competitorOwnerName: string;
  competitorSellerName: string;
  competitorFulfillerName: string;
  competitorProductName: string | null;
  competitorRegionName: string;
  competitorRegularPrice: number;
  competitorLowestPrice: number;
  competitorLowestPriceType: string;
};
export namespace AlertResultsList {
  export type Request = {
    sourceOwnerId: string | null;
    sourceCategoryId: string | null;
    uniqueIdentifier: string | null;
    wml: keyof typeof WML | null;
    maxVarience: number | null;
    minVarience: number | null;
    alertId: string | null;
    sourceRatingCount: string | null;
    createdDate: string | null;
    matchType: MatchType | null;
    priceType: VarianceType | null;
    sourceRegionId: string | null;
    competitorOwnerId: string | null;
    competitorSellerName: string | null;
    competitorFulfillerName: string | null;
    sortingOrder: 'asc' | 'desc';
    sortingColumn: keyof AlertResult;
    size: number;
    offset: number;
  };

  export type Response = {
    alertResultList: AlertResult[];
    totalRecords: string;
    sortingorder: string;
    sortingcolumn: string;
    size: string;
    offset: string;
  };
}
